module.exports = __webpack_public_path__ + "static/media/17.c89f3076.jpg";